import React, { useState } from 'react';

const faqs = [
  {
    question: 'What warehouse management capabilities does Infor WMS provide?',
    answer:
      'Infor WMS provides comprehensive warehouse management capabilities including receiving, put-away, inventory management, picking, packing, shipping, cross-docking, wave planning, and cycle counting. It offers real-time inventory visibility, lot and serial number tracking, multi-warehouse management, and advanced labor management features. The system supports various warehouse automation technologies including barcode scanning, RFID, voice picking, conveyor systems, AS/RS, and pick-to-light systems.',
  },
  {
    question: 'How does Infor WMS integrate with other enterprise systems?',
    answer:
      'Infor WMS integrates seamlessly with ERP systems (Infor LN, M3, CSI), Infor OS, e-commerce platforms, Transportation Management Systems (TMS), Manufacturing Execution Systems (MES), and third-party logistics (3PL) systems. Integration options include Infor ION, REST APIs, SOAP web services, EDI, and pre-built connectors. This ensures real-time data synchronization, accurate inventory visibility, and efficient order fulfillment across your entire supply chain.',
  },
  {
    question: 'What industries does Infor WMS support?',
    answer:
      'Infor WMS serves a wide range of industries including manufacturing, distribution, retail, third-party logistics (3PL), food & beverage, pharmaceuticals, automotive, consumer goods, e-commerce, and wholesale distribution. It addresses industry-specific requirements such as cold chain management, serialization, regulatory compliance, bulk inventory management, omnichannel fulfillment, and high-volume order processing.',
  },
  {
    question: 'Can you help with Infor WMS implementation and deployment?',
    answer:
      'Yes. We provide end-to-end Infor WMS implementation services including warehouse process assessment, solution design and architecture, system configuration, business process setup, go-live planning and deployment, and comprehensive user acceptance testing (UAT). Our methodology ensures smooth deployment with minimal operational disruption and maximum user adoption.',
  },
  {
    question: 'Do you offer training and documentation for Infor WMS?',
    answer:
      'Yes. We provide comprehensive training programs covering warehouse operators, supervisors, administrators, and technical users. Our training includes role-based sessions, hands-on practice scenarios, user documentation, SOPs, and knowledge transfer. We ensure your warehouse teams are confident and proficient in using Infor WMS capabilities to maximize operational efficiency.',
  },
  {
    question: 'How does Infor WMS support warehouse automation?',
    answer:
      'Infor WMS integrates with various warehouse automation technologies including barcode scanning, RFID, voice picking, conveyor systems, AS/RS (Automated Storage and Retrieval Systems), pick-to-light systems, and robotics. Our team helps design and implement automation solutions that improve accuracy, increase throughput, reduce labor costs, and enhance overall warehouse productivity.',
  },
  {
    question: 'What reporting and analytics capabilities does Infor WMS offer?',
    answer:
      'Infor WMS provides comprehensive reporting and analytics capabilities including warehouse dashboards, KPI reporting, inventory analytics, labor analytics, operational reporting, and executive dashboards. It offers real-time visibility into warehouse performance, inventory levels, order fulfillment metrics, and labor productivity. These insights enable data-driven decision-making and continuous process improvement.',
  },
  {
    question: 'Do you support Infor WMS upgrades and cloud migration?',
    answer:
      'Yes. We provide complete upgrade and cloud migration services for Infor WMS including version upgrades, system modernization, performance optimization, and upgrade testing. Our team manages the entire process from assessment through deployment, ensuring a smooth transition with minimal business disruption while leveraging new features and cloud capabilities.',
  },
  {
    question: 'What ongoing support and managed services do you offer for Infor WMS?',
    answer:
      'We provide comprehensive ongoing support including 24/7 application support, incident management, performance monitoring, preventive maintenance, SLA-based support, and continuous improvements. Our managed services ensure your Infor WMS environment remains stable, secure, optimized, and aligned with evolving warehouse operations and business requirements.',
  },
  {
    question: 'How does Infor WMS improve warehouse productivity and accuracy?',
    answer:
      'Infor WMS improves warehouse productivity through optimized put-away strategies, efficient picking and packing processes, wave planning optimization, and labor management capabilities. It enhances accuracy through barcode scanning, RFID tracking, real-time validation, and system-guided workflows. Organizations typically achieve 45% faster order fulfillment, 35% improved inventory accuracy, 30% labor productivity increase, and 90% reduction in shipping errors.',
  },
];

const WMSFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-12 bg-[#ffffff]">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
          Frequently Asked Questions
        </h2>

        <div className="mx-auto max-w-4xl space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={faq.question}
                className="overflow-hidden rounded-xl border transition-all duration-200"
                style={{
                  backgroundColor: '#FFFFFF',
                  borderColor: isOpen ? '#4B5563' : '#E2E8F0',
                  boxShadow: isOpen ? '0 4px 20px rgba(14, 165, 164, 0.1)' : 'none',
                }}
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span 
                    className="text-lg font-semibold transition-colors duration-200"
                    style={{ color: isOpen ? '#4B5563' : '#1A2634' }}
                  >
                    {faq.question}
                  </span>
                  <span 
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xl font-bold transition-colors duration-200"
                    style={{ 
                      backgroundColor: isOpen ? '#4B5563' : '#F1F5F9',
                      color: isOpen ? '#FFFFFF' : '#64748B'
                    }}
                  >
                    {isOpen ? '-' : '+'}
                  </span>
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-6 text-base leading-7 text-gray-600">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WMSFAQ;